import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/sigef';

export default {
    consultarCpfCnpj(cpfCnpj) {
        return http.get({
            url: baseUrl + `/consulta/cpfcnpj/${cpfCnpj}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.sigefConsultandoCpfCnpj')
        });
    },

    consultarINCRA(incra) {
        return http.get({
            url: baseUrl + `/consulta/incra/${incra}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.sigefConsultandoNumeroDoIncra')
        });
    },

    buscarGeometriaParcela(codigoParcela) {
        return http.get({
            url: baseUrl + `/${codigoParcela}/geometria`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.sigefBuscandoGeometriaDaParcela')
        });
    }
};
